import { graphql } from "gql.tada";
import { RichTextFragment } from "../fragments/RichTextFragment";
import { LinkFragment } from "../fragments/LinkFragment";

export const AudienceCulturalInfluenceSectionById = graphql(
  `
    query AudienceCulturalInfluenceSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      audienceCulturalInfluenceSection(
        id: $id
        preview: $preview
        locale: $locale
      ) {
        ...AudienceCulturalInfluenceFragment
      }
    }

    fragment AudienceCulturalInfluenceFragment on AudienceCulturalInfluenceSection {
      title
      numberTitle
      isPercentage
      description
      ctaLink {
        ...LinkFragment
      }
      mediaGallery {
        mediaItemsCollection(limit: 30) {
          items {
            title
            itemMedia {
              url
              contentType
            }
          }
        }
      }
      sourceInfo {
        ...RichTextFragment
      }
    }
  `,
  [LinkFragment, RichTextFragment]
);
